import { RESET_API_ERRORS } from "../constants/actions";
import { GET_API_ERRORS } from "../constants/getters";
import { ADD_API_ERROR, SET_API_ERRORS } from "../constants/mutations";

export default {
  state: {
    not_sync_errors: {
      api: [],
    },
  },
  getters: {
    [GET_API_ERRORS](state){ return state.not_sync_errors.api },
  },
  actions: {
    [RESET_API_ERRORS]({ commit }){
      commit(SET_API_ERRORS)
    },
  },
  mutations: {
    [SET_API_ERRORS](state,data){ 
      state.not_sync_errors.api=data ?? []
    },
    [ADD_API_ERROR](state,data){ 
      state.not_sync_errors.api.push(data)
    },
  },
};